import React, { useState } from 'react';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext'; // Contexto de autenticación
import '../styles/sales.css';

function SalesPage() {
  const { token, logout } = useAuth(); // Obtener el token y la función de logout del contexto
  const [activeTab, setActiveTab] = useState('cancel'); // 'cancel' or 'packing'
  const [poNumber, setPoNumber] = useState('');
  const [reason, setReason] = useState('');
  const [packing, setPacking] = useState('');

  const handleCancelOrder = async () => {
    if (!poNumber || !reason) {
      alert('Por favor, ingrese un número de orden y una razón.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/cancel-po/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({ po_number: poNumber, reason }),
      });

      if (response.ok) {
        alert('Orden cancelada con éxito.');
        setPoNumber(''); // Limpiar el campo de entrada
        setReason(''); // Limpiar la razón
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'No se pudo cancelar la orden.'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al cancelar la orden. Por favor, intente nuevamente.');
    }
  };

  const handlePackingUpdate = async () => {
    if (!poNumber || !packing) {
      alert('Por favor, ingrese un número de orden y seleccione el estado de embalaje.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/pack-po/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({
          po_number: poNumber,
          packing: packing === 'true'
        }),
      });

      if (response.ok) {
        alert('Estado de embalaje actualizado con éxito.');
        setPoNumber('');
        setPacking('');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'No se pudo actualizar el estado de embalaje.'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al actualizar el estado de embalaje. Por favor, intente nuevamente.');
    }
  };

  const handleLogout = () => {
    logout(); // Llamar a la función de logout del contexto
  };

  return (
    <div className="sales-container">
      <button className="sales-logout-button" onClick={handleLogout}>
        Cerrar Sesión
      </button>

      <div className="sales-content">
        <h1 className="sales-heading">Panel de Ventas</h1>

        <div className="sales-tabs">
          <button
            className={`sales-tab ${activeTab === 'cancel' ? 'active' : ''}`}
            onClick={() => setActiveTab('cancel')}
          >
            Cancelar Orden
          </button>
          <button
            className={`sales-tab ${activeTab === 'packing' ? 'active' : ''}`}
            onClick={() => setActiveTab('packing')}
          >
            Gestionar Embalaje
          </button>
        </div>

        <div className="sales-form-container">
          {activeTab === 'cancel' ? (
            <form
              className="sales-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleCancelOrder();
              }}
            >
              <div className="form-group">
                <label>Número de Orden</label>
                <input
                  type="text"
                  placeholder="Ingrese el número de orden"
                  className="sales-input"
                  value={poNumber}
                  onChange={(e) => setPoNumber(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Razón de Cancelación</label>
                <textarea
                  placeholder="Ingrese la razón de cancelación"
                  className="sales-input"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </div>
              <button type="submit" className="sales-button cancel">
                Cancelar Orden
              </button>
            </form>
          ) : (
            <form
              className="sales-form"
              onSubmit={(e) => {
                e.preventDefault();
                handlePackingUpdate();
              }}
            >
              <div className="form-group">
                <label>Número de Orden</label>
                <input
                  type="text"
                  placeholder="Ingrese el número de orden"
                  className="sales-input"
                  value={poNumber}
                  onChange={(e) => setPoNumber(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Estado de Embalaje</label>
                <select
                  className="sales-select"
                  value={packing}
                  onChange={(e) => setPacking(e.target.value)}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="true">Si</option>
                  <option value="false">No</option>
                </select>
              </div>
              <button type="submit" className="sales-button update">
                Actualizar Estado
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesPage;
